export default __webpack_public_path__ + "static/B.O.B-e967b1177588094259eaf418799b476c.webp";